import { createGlobalStyle } from 'styled-components';

declare module 'styled-components' {
  export interface DefaultTheme {
    token: {
      colorPrimary: string;
      colorBgLayout: string;
      colorTextDescription: string;
      colorFillSecondary: string;
      colorTextSecondary: string;
      colorBorderSecondary: string;
      colorPrimaryBorder: string;
      colorTextTertiary: string;
      colorInstruction: string;
    };
    advanceTheme: Record<string, string | number>;
  }
}

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-weight: 700;
    font-family: Inter;
    font-style: normal;
    src: url('../fonts/Inter/Inter-Bold.ttf') format('truetype');
    font-display: fallback;
  }

  @font-face {
    font-weight: 500;
    font-family: Inter;
    font-style: normal;
    src: url('../fonts/Inter/Inter-Medium.ttf') format('truetype');
    font-display: fallback;
  }

  @font-face {
    font-weight: 400;
    font-family: Inter;
    font-style: normal;
    src: url('../fonts/Inter/Inter-Regular.ttf') format('truetype');
    font-display: fallback;
  }
  @font-face {
    font-weight: 700;
    font-family: Noto Sans TC;
    font-style: normal;
    src: url('../fonts/Noto_Sans_TC/NotoSansTC-Bold.otf') format('opentype');
    font-display: fallback;
  }

  @font-face {
    font-weight: 500;
    font-family: Noto Sans TC;
    font-style: normal;
    src: url('../fonts/Noto_Sans_TC/NotoSansTC-Medium.otf') format('opentype');
    font-display: fallback;
  }

  @font-face {
    font-weight: 400;
    font-family: Noto Sans TC;
    font-style: normal;
    src: url('../fonts/Noto_Sans_TC/NotoSansTC-Regular.otf') format('opentype');
    font-display: fallback;
  }

  body {
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    #root-master,
    #root {
      height: 100%;
      > .ant-design-pro {
        height: 100%;
      }
    }

    a {
      color: ${({ theme }) => theme.token.colorPrimary};  
      text-decoration: none;
      background-color: transparent;
      outline: none;
      cursor: pointer;
      transition: color 0.3s;
    }

    .ant-space {
      width: inherit;

      .ant-space-item {
        width: inherit;
      }
    }

    .ant-pro-table-column-setting-overlay {
      .ant-popover-inner-content {
        width: 360px;
      }
    }

    .ant-table-wrapper .ant-table.ant-table-middle .ant-table-tbody .ant-table-wrapper:only-child .ant-table {
      margin-inline: 40px 0px;
    }

    .ant-pro-card-statistic-content .ant-statistic-content-value-int {
      font-size: inherit;
    }

    /* Layout style */
    .ant-pro-page-container > .ant-page-header > .ant-page-header-heading .ant-typography {
      color: ${({ theme }) => theme.token.colorTextSecondary};
      font-size: 20px;
    }
    .ant-pro-page-container > .ant-pro-grid-content > .ant-pro-grid-content-children > .ant-pro-page-container-children-container {
      padding-inline: 24px;
      padding-block: 16px;
    }
    .ant-layout-content > .ant-pro-page-container > .ant-page-header {
      padding-block: 16px;
      padding-inline: 24px;
    }

    .ant-page-header-footer > .ant-divider {
      margin: 14px 0;
    }

    .ant-pro-base-menu-inline-item-title .ant-pro-base-menu-inline-item-text,
    .ant-pro-base-menu-inline-item-title .ant-pro-base-menu-inline-item-text.ant-pro-base-menu-inline-item-text-has-icon,
    .ant-menu-submenu-popup .ant-pro-base-menu-inline-item-text {
      white-space: normal;
      overflow: visible;
      text-overflow: clip;
      word-break: break-word;
      line-height: 20px;
    }
    .ant-menu-submenu-popup > .ant-menu {
      min-width: 280px;
    }
    .ant-pro-base-menu-inline .ant-menu-item,
    .ant-pro-base-menu-inline .ant-menu-submenu-title,
    .ant-menu-submenu-popup .ant-menu-item,
    .ant-menu-submenu-popup .ant-menu-submenu-title {
      height: auto;
      min-height: 40px;
      line-height: 20px;
      display: flex;
      align-items: center;
      padding-top: 10px;
      padding-bottom: 10px;
    }
    .ant-pro-sider-collapsed .ant-pro-base-menu-inline .ant-menu-item,
    .ant-pro-sider-collapsed .ant-pro-base-menu-inline .ant-menu-submenu-title {
      padding-top: 0;
      padding-bottom: 0;
      min-height: 48px;
    }
    .ant-pro-sider-collapsed .ant-pro-base-menu-inline .ant-menu-title-content,
    .ant-menu-submenu-popup .ant-menu-title-content {
      height: 100%;
      display: flex;
      align-items: center;
    }

    /* custom style */
    .ant-card {
      padding: 16px 24px;
      .ant-card-head {
        padding: 0;
        padding-bottom: 8px;
      }
      .ant-card-body {
        padding: 0;
      }
    }
    .ant-menu-item-group-title .ant-pro-base-menu-inline-item-icon {
        display: none;
    }
    .ant-pro-sider-collapsed .ant-menu-title-content {
      .ant-menu-item-group-title .ant-pro-base-menu-inline-item-icon {
        display: block;
      }
    }
    .ant-statistic .ant-statistic-title, .ant-pro-card-statistic .ant-statistic-title {
      color: ${({ theme }) => theme.token.colorTextSecondary};  
    }
    .ant-statistic .ant-statistic-content {
      font-size: 30px;
    }
    .ant-card .ant-card-head {
      font-weight: 500;
    }
    .ant-table-wrapper .ant-table-thead >tr>th, .ant-table-wrapper .ant-table-thead >tr>td {
      background: ${({ theme }) => theme.token.colorFillSecondary};  
    }
    .ant-table-wrapper .ant-table-cell-scrollbar:not([rowspan]) {
      box-shadow: initial;
    }
    h4.ant-typography, div.ant-typography-h4, .ant-typography h4 {
      margin-bottom: 0;
    }
    .ant-segmented {
      background: #f5f5f5;
    }
    .user-dropdown ul.ant-dropdown-menu-item-group-list {
      max-height: 530px;
      overflow-y: auto;
    }
    /* custom style end */

    @media print {
      html,
      body {
        height: initial !important;
        overflow: initial !important;
      }
    }
    @media print {
      .page-break {
        margin-top: 1rem;
        page-break-inside: avoid;
      }
    }

    // 兼容IE11
    @media screen and(-ms-high-contrast: active), (-ms-high-contrast: none) {
      body .ant-design-pro > .ant-layout {
        min-height: 100vh;
      }
    }
  }
`;
